import { createBrowserRouter, Navigate } from 'react-router-dom';
import Layout from '@/layout/Layout';
import Catalogue from '@/pages/catalogue/Catalogue';
import ItemDetail from '@/pages/itemDetail/ItemDetail';
import ValidationRules from '@/pages/ValidationRules';
import {
  AudiencesPage,
  CategoriesPage,
  DeviceTypesPage,
  GenresPage,
  ProvidersPage,
  RatingsPage,
  ShowTypesPage,
} from '@/pages/config/pages';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Navigate to="/catalogue" replace /> },
      { path: 'catalogue', element: <Catalogue /> },
      // The version is part of the identity: one asset can be ingested repeatedly.
      { path: 'catalogue/:assetId/:version', element: <ItemDetail /> },
      { path: 'rules', element: <ValidationRules /> },
      { path: 'config/genres', element: <GenresPage /> },
      { path: 'config/ratings', element: <RatingsPage /> },
      { path: 'config/show-types', element: <ShowTypesPage /> },
      { path: 'config/audiences', element: <AudiencesPage /> },
      { path: 'config/device-types', element: <DeviceTypesPage /> },
      { path: 'config/categories', element: <CategoriesPage /> },
      { path: 'config/providers', element: <ProvidersPage /> },
      { path: '*', element: <Navigate to="/catalogue" replace /> },
    ],
  },
]);
